import { useContext } from 'react'
import { Dialog } from '@material-ui/core'

import AppsVersionContext from 'components/contexts/AppsVersionContext'
import ContactCenterUserContext from 'components/contexts/ContactCenterUserContext'
import { UnleashContext } from 'components/providers/UnleashProvider'
import config from 'config'
import ModuleFederationLoader from 'utils/ModuleFederationLoader'

export interface DialogSetupDialogProps {
  isDynamicSetupOpen: boolean
  onDialogClosed: (userDismiss: boolean) => void
  onCompleteSetup: () => void
}

const DynamicSetupDialog = ({
  isDynamicSetupOpen,
  onDialogClosed,
  onCompleteSetup,
}: DialogSetupDialogProps): JSX.Element => {
  const { copilotAIEnabled } = useContext(UnleashContext)
  const { userContext } = useContext(ContactCenterUserContext) || {}
  const { contactCenterTargetBuild: targetBuild } = useContext(AppsVersionContext) || {}

  return (
    <Dialog fullScreen disableEnforceFocus open={isDynamicSetupOpen} disableEscapeKeyDown>
      <ModuleFederationLoader
        module="dynamicSetupApp"
        subAppModuleFederation={config.subAppsModuleFederation.uccUnifiedAdminDynamicSetup}
        onClose={onDialogClosed}
        onCompleteSetup={onCompleteSetup}
        initSentry={false}
        copilotAIEnabled={copilotAIEnabled}
        contactCenterContext={{ userContext, targetBuild }}
      />
    </Dialog>
  )
}

export default DynamicSetupDialog
